import { render, staticRenderFns } from "./SgRecommend.vue?vue&type=template&id=17b15442&scoped=true&"
import script from "./SgRecommend.vue?vue&type=script&lang=js&"
export * from "./SgRecommend.vue?vue&type=script&lang=js&"
import style0 from "./SgRecommend.vue?vue&type=style&index=0&id=17b15442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b15442",
  null
  
)

export default component.exports